<div>
  {{ 'new-app-version-notification.text.new-version-available' | translate }}
</div>
<button mat-flat-button color="primary" (click)="reload()">
  {{ 'new-app-version-notification.buttons.update' | translate }}
</button>
